import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api, authApi } from "../../config/api";
import { toast } from "react-toastify";

// Async thunk for get internal tracker for candidate
// export const getTrackerDetails = createAsyncThunk(
//   "candidate/internal-tracker",
//   async (queryString, { rejectWithValue }) => {
//     try {
//       const response = await api.get(`/recruiter/candidate-tracker/${queryString}`);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

export const getTrackerDetails = createAsyncThunk(
  "candidate/internal-tracker",
  async (queryString, { rejectWithValue }) => {
    try {
      // Use the query string directly in the API call
      const response = await api.get(
        `/recruiter/candidate-tracker/?${queryString}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getAllRecruiterCandidateNextPrevious = createAsyncThunk(
  "candidate/internal-tracker/next-previous",
  async (url, { rejectWithValue }) => {
    try {
      // Use the query string directly in the API call
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for create internal Tracker
export const createCandidatetracker = createAsyncThunk(
  "create/internal-tracker",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/recruiter/candidate-tracker/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update bdm profile
export const updateCandidatetracker = createAsyncThunk(
  "update/internal-tracker",
  async ({ updatedValues, id }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/recruiter/candidate-tracker/${id}/`,
        updatedValues
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for process resume
export const resumeProcces = createAsyncThunk(
  "resume/process",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await authApi.post(
        "/manager/process-resume/",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get internal tracker card data for candidate
export const getAllInternalCandidateCard = createAsyncThunk(
  "candidate/card-data",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/recruiter/consultants/counts/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get internal tracker  submission count
export const getTrackerSubmisionCount = createAsyncThunk(
  "candidate/internal-tracker-submission-count",
  async (parameter, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/recruiter/candidate-requirement-tracker-submission-count/?candidate_email=${parameter}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// export const getTrackerSubmisionCount = createAsyncThunk(
//   "candidate/internal-tracker-submission-count",
//   async (userData, { rejectWithValue }) => {
//     try {
//       const response = await api.request({
//         method: "GET",
//         url: "/recruiter/candidate-requirement-tracker-submission-count/",
//         data: userData, // Include body data
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// Async thunk for update action internal tracker
export const updateTrackerAction = createAsyncThunk(
  "action/internal-tracker",
  async ({ updatedValues, id }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/recruiter/candidate-tracker/${id}/`,
        updatedValues
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getOneTrackerDetails = createAsyncThunk(
  "candidate/internal-tracker-one-details",
  async (ID, { rejectWithValue }) => {
    try {
      // Use the query string directly in the API call
      const response = await api.get(`/recruiter/candidate-tracker/${ID}/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getNextTrackerDetailas = createAsyncThunk(
  "candidate/internal-tracker-next",
  async (linkID, { rejectWithValue }) => {
    try {
      // Use the query string directly in the API call
      const response = await api.get(linkID);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getTrackerNotes = createAsyncThunk(
  "get/tracker_note",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/recruiter/review-status/?candidate_id=${ID}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addCommentsNotes = createAsyncThunk(
  "create/tracker_note",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/recruiter/candidate-review/", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateTrackerNotes = createAsyncThunk(
  "update/tracker_note",
  async ({ userData, ID }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/recruiter/review-status/?candidate_id=${ID}`,
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteCommentsNotes = createAsyncThunk(
  "delete/tracker_note",
  async ({ ID, userData }, { rejectWithValue }) => {
    try {
      const response = await api.delete(
        `/recruiter/candidate-review/?candidate_id=${ID}`,
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const checkIsCandidateAlreadyExist = createAsyncThunk(
  "check/candidate_exist",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/recruiter/candidate-tracker/validate/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const internalCompanyTrackingCount = createAsyncThunk(
  "internal-tracker/internal-company-count",
  async ({ candidate_id, candidate_email }, { rejectWithValue }) => {
    try {
      // Use the query string directly in the API call
      const response = await api.get(
        `/recruiter/candidate-requirement-tracker-submission-count/?candidate_id=${candidate_id}&candidate_email=${candidate_email}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const internalCandidateRequirementList = createAsyncThunk(
  "internal-tracker/candidate-requirement",
  async (candidate_email, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/req/requirement-history/${candidate_email}/`
        // `/recruiter/candidate-requirement-tracker-list/${candidate_email}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const postInternalViewcount = createAsyncThunk(
  "internal-tracker/view",
  async (candidate_id, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/recruiter/view-count-update/${candidate_id}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const trackerSlice = createSlice({
  name: "tracker",
  initialState: {
    data: null,
    resumeData: null,
    cardData: null,
    submissionCountData: null,
    candidateDetails: null,
    gitMotesDetails: null,
    checkCandidateExistresult: null,
    candidateDetailsSubmisionList: null,
    candidateDetailsSubmisionCount: null,
    candidateNotesStatus: "idle",
    candidateDetailStatus: "idle",
    candidateDetailStatusss: "idle",
    status: "idle",
    candidateDetailStatusssL: "idle",
    error: null,
  },

  extraReducers: (builder) => {
    builder
      .addCase(getTrackerDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getTrackerDetails.fulfilled, (state, action) => {
        state.status = "get_candidate_intenal_succeeded";
        state.data = action.payload;
      })
      .addCase(getTrackerDetails.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload.message);
      })
      .addCase(getAllRecruiterCandidateNextPrevious.pending, (state) => {
        state.status = "loading";
      })
      .addCase(
        getAllRecruiterCandidateNextPrevious.fulfilled,
        (state, action) => {
          state.status = "get_candidate_intenal_succeeded";
          state.data = action.payload;
        }
      )
      .addCase(
        getAllRecruiterCandidateNextPrevious.rejected,
        (state, action) => {
          state.status = "failed";
          toast.error(action.payload.message);
        }
      )
      .addCase(createCandidatetracker.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createCandidatetracker.fulfilled, (state, action) => {
        console.log({ action });

        state.status = "create_candidate_intenal_succeeded";
        toast.success(action.payload.message);
      })
      .addCase(createCandidatetracker.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(updateCandidatetracker.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateCandidatetracker.fulfilled, (state, action) => {
        state.status = "update_candidate_intenal_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(updateCandidatetracker.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(resumeProcces.pending, (state) => {
        state.status = "loading";
      })
      .addCase(resumeProcces.fulfilled, (state, action) => {
        state.status = "resume_process_succeeded";
        state.resumeData = action.payload;
        toast.success(action.payload.message);
      })
      .addCase(resumeProcces.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload.message);
      })
      .addCase(getAllInternalCandidateCard.pending, (state) => {
        state.cardDataStatus = "loading";
      })
      .addCase(getAllInternalCandidateCard.fulfilled, (state, action) => {
        state.cardDataStatus = "get_candidate_intenal_card_succeeded";
        state.cardData = action.payload;
      })
      .addCase(getAllInternalCandidateCard.rejected, (state, action) => {
        state.cardDataStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getTrackerSubmisionCount.pending, (state) => {
        state.candidateDetailStatus = "loading";
      })
      .addCase(getTrackerSubmisionCount.fulfilled, (state, action) => {
        state.candidateDetailStatus = "get_candidate_intenal_succeeded";
        state.submissionCountData = action.payload;
      })
      .addCase(getTrackerSubmisionCount.rejected, (state, action) => {
        state.candidateDetailStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(updateTrackerAction.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateTrackerAction.fulfilled, (state, action) => {
        state.status = "update_candidate_tracker_action";
        toast.success(action.payload?.message);
      })
      .addCase(updateTrackerAction.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getOneTrackerDetails.pending, (state) => {
        state.candidateDetailStatus = "loading";
      })
      .addCase(getOneTrackerDetails.fulfilled, (state, action) => {
        state.candidateDetailStatus = "intenal_candidate_details_succeeded";
        state.candidateDetails = action.payload;
      })
      .addCase(getOneTrackerDetails.rejected, (state, action) => {
        state.candidateDetailStatus = "failed";
        // toast.error(action.payload?.message);
      })
      .addCase(getNextTrackerDetailas.pending, (state) => {
        state.candidateDetailStatus = "loading";
      })
      .addCase(getNextTrackerDetailas.fulfilled, (state, action) => {
        state.candidateDetailStatus =
          "intenal_candidate_details_next_succeeded";
        state.candidateDetails = action.payload;
      })
      .addCase(getNextTrackerDetailas.rejected, (state, action) => {
        state.candidateDetailStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getTrackerNotes.pending, (state) => {
        state.candidateNotesStatus = "loading";
      })
      .addCase(getTrackerNotes.fulfilled, (state, action) => {
        state.candidateNotesStatus = "get_tracker_note_succeeded";
        state.gitMotesDetails = action.payload;
      })
      .addCase(getTrackerNotes.rejected, (state, action) => {
        state.candidateNotesStatus = "failed";
        toast.error(action?.payload?.message);
      })
      .addCase(addCommentsNotes.pending, (state) => {
        state.candidateNotesStatus = "loading";
      })
      .addCase(addCommentsNotes.fulfilled, (state, action) => {
        state.candidateNotesStatus = "create_tracker_note_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(addCommentsNotes.rejected, (state, action) => {
        state.candidateNotesStatus = "failed";
        toast.error(action?.payload?.message);
      })
      .addCase(updateTrackerNotes.pending, (state) => {
        state.candidateNotesStatus = "loading";
      })
      .addCase(updateTrackerNotes.fulfilled, (state, action) => {
        state.candidateNotesStatus = "update_tracker_note_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(updateTrackerNotes.rejected, (state, action) => {
        state.candidateNotesStatus = "failed";
        toast.error(action?.payload?.message);
      })
      .addCase(deleteCommentsNotes.pending, (state) => {
        state.candidateNotesStatus = "loading";
      })
      .addCase(deleteCommentsNotes.fulfilled, (state, action) => {
        state.candidateNotesStatus = "delete_tracker_note_succeeded";
        toast.success(action.payload?.message);
      })
      .addCase(deleteCommentsNotes.rejected, (state, action) => {
        state.candidateNotesStatus = "failed";
        toast.error(action?.payload?.message);
      })
      .addCase(checkIsCandidateAlreadyExist.pending, (state) => {
        state.status = "loading";
      })
      .addCase(checkIsCandidateAlreadyExist.fulfilled, (state, action) => {
        state.status = "check_candidate_exist_succeeded";
        state.checkCandidateExistresult = action.payload;
        toast.success(action.payload?.message);
      })
      .addCase(checkIsCandidateAlreadyExist.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action?.payload?.message);
      })
      .addCase(internalCompanyTrackingCount.pending, (state) => {
        state.candidateDetailStatusss = "loading";
      })
      .addCase(internalCompanyTrackingCount.fulfilled, (state, action) => {
        state.candidateDetailStatusss = "intenal_company_tracking_count";
        state.candidateDetailsSubmisionCount = action.payload;
      })
      .addCase(internalCompanyTrackingCount.rejected, (state, action) => {
        state.candidateDetailStatusss = "failed";
        // toast.error(action.payload?.message);
      })
      .addCase(internalCandidateRequirementList.pending, (state) => {
        state.candidateDetailStatusss = "loading";
      })
      .addCase(internalCandidateRequirementList.fulfilled, (state, action) => {
        state.candidateDetailStatusss = "intenal_company_trequirement_list";
        state.candidateDetailsSubmisionList = action.payload;
      })
      .addCase(internalCandidateRequirementList.rejected, (state, action) => {
        state.candidateDetailStatusss = "failed";
        // toast.error(action.payload?.message);
      })
      .addCase(postInternalViewcount.pending, (state) => {
        state.candidateDetailStatusss = "loading";
      })
      .addCase(postInternalViewcount.fulfilled, (state, action) => {
        state.candidateDetailStatusss = "internal_view_count";
      })
      .addCase(postInternalViewcount.rejected, (state, action) => {
        state.candidateDetailStatusss = "failed";
        // toast.error(action.payload?.message);
      });
  },
});

export default trackerSlice.reducer;
